import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconReverseSpeed({
  onClick,
  isAutoscallable = true,
  sizeKey = '20x20',
  style,
}: ActualIconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconReverseSpeed', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.3945 2.55156C11.3687 1.72407 10.13 1.20302 8.8211 1.04836C7.51219 0.893705 6.18621 1.11172 4.99573 1.67733C3.80525 2.24294 2.79864 3.13316 2.09173 4.24556C1.38482 5.35796 1.00632 6.64733 0.99979 7.96533C0.993262 9.28333 1.35897 10.5764 2.05483 11.6957C2.75069 12.8151 3.74843 13.7152 4.93325 14.2926C6.11807 14.87 7.44182 15.1011 8.75219 14.9594C10.0626 14.8178 11.3063 14.309 12.3403 13.4917"
        stroke="white"
      />
      <path
        d="M14.8669 8.59417L13.0487 10.4123C12.9851 10.4759 12.9041 10.5192 12.816 10.5367C12.7278 10.5543 12.6364 10.5453 12.5533 10.5109C12.4703 10.4765 12.3993 10.4182 12.3493 10.3435C12.2994 10.2687 12.2727 10.1808 12.2727 10.0909V8.72728H5.45454C5.33399 8.72728 5.21838 8.67939 5.13313 8.59415C5.04789 8.5089 5 8.39329 5 8.27274C5 8.15218 5.04789 8.03657 5.13313 7.95132C5.21838 7.86608 5.33399 7.81819 5.45454 7.81819H12.2727V6.45456C12.2727 6.36466 12.2994 6.27677 12.3493 6.20202C12.3993 6.12727 12.4703 6.06901 12.5533 6.0346C12.6364 6.0002 12.7278 5.9912 12.816 6.00873C12.9041 6.02627 12.9851 6.06956 13.0487 6.13312L14.8669 7.9513C14.9521 8.03656 15 8.15218 15 8.27274C15 8.39329 14.9521 8.50891 14.8669 8.59417Z"
        fill="white"
      />
    </svg>
  );
}
